import Marquee from "react-fast-marquee";
import { CONVENTIONS } from "@/lib/constants";
import { Reveal } from "./Reveal";

export const Conventions = () => (
  <section className="py-16 sm:py-24" data-testid="conventions">
    <Reveal className="px-5 sm:px-8 lg:px-12 text-center">
      <p className="mb-3 text-xs uppercase tracking-[0.3em] text-ocean-deep">Il percorso</p>
      <h2 className="mx-auto max-w-3xl font-serif text-2xl sm:text-3xl leading-snug text-navy-soft text-balance">
        Ospiti di alcune tra le principali manifestazioni italiane dedicate al fumetto, al cosplay e alla cultura pop.
      </h2>
    </Reveal>

    <div className="mt-12">
      <Marquee gradient gradientColor="#FCFBFF" gradientWidth={120} speed={38} pauseOnHover>
        {CONVENTIONS.concat(CONVENTIONS).map((name, i) => (
          <span key={i} className="mx-6 inline-flex items-center gap-6">
            <span className="font-serif text-2xl sm:text-3xl text-navy/30 transition-colors duration-300 hover:text-lavender-deep">
              {name}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-lavender/50" />
          </span>
        ))}
      </Marquee>
    </div>
  </section>
);
